export const gridSpacing = 2.6;